import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { userApi } from "@/api/user/userApi";
import TagManager from "react-gtm-module";
import { User } from "@/api/user/userTypes";
import { Page } from "./Page";

export interface PageOutletContext {
  currentUser: User;
}

export function PageOutlet() {
  const [currentUser, setCurrentUser] = useState<User>();

  // Needed to remove the navigation header for the 3ds iframe

  const fetchCurrentUser = async () => {
    try {
      const user = await userApi.fetchLoggedInUser();
      setCurrentUser(user);
      const tagManagerArgs = {
        dataLayer: {
          userSfId: user.sfId,
          userId: user._id,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  return (
    <Page currentUser={currentUser}>
      <Outlet context={{ currentUser }} />
    </Page>
  );
}
